import styled from 'styled-components'

export const GaugeDiv = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: row;
    justify-content: left;
`
